// extracted by mini-css-extract-plugin
export default {"activePatientsTable":"active-patients-table_activePatientsTable__9jZqE"};